import { Box, Breadcrumbs, Grid, Heading } from "@itandi/itandi-bb-ui";
import type React from "react";
import type { ComponentProps } from "react";
import { DealTypeLabel } from "~/components/common/parts/label/DealTypeLabel";
import type { Deal } from "~/models/Deal";
import Styles from "./SimpleHeader.module.scss";

type Props = {
	deal: Deal;
	items: ComponentProps<typeof Breadcrumbs>["items"];
};

export const SimpleHeaderVendorSP: React.FC<Props> = ({
	deal,
	items
}: Props) => (
	<Box position="sticky" top={0} width="100%">
		<div className={Styles.SimpleHeader} id="deal_header">
			<Box>
				<Breadcrumbs items={items} />
				<Grid autoFlow="column" justifyContent="start">
					<Box margin=".25rem">
						<DealTypeLabel
							dealSubtype={deal.dealSubtype}
							dealType={deal.dealType}
						/>
					</Box>
					<Heading as="h2">{`${deal.name} ${deal.roomNumber}`}</Heading>
				</Grid>
			</Box>
		</div>
	</Box>
);
